export default {
  /** ***********公共********************/
  // 公共菜单信息
  configMenu: '/common/config/menu',
  // 头条信息
  configNotice: '/common/config/notice',
  // 用户信息
  userInfo: '/pc/home/user/getUserInfo',
  // 发送短信验证码
  sendValidateCode: '/common/sms/sendValidateCode',
  // 上传图片
  uploadImg: '/common/upload/img',
  // 类目信息
  getCategory: '/common/category/getCategory',

  /** ************登录注册********************/
  // 主播注册
  anchorRegister: '/pc/home/login/anchorRegister',
  // 商家/主播忘记密码
  forgetPassword: '/pc/home/login/forgetPassword',
  // 商家/主播登录
  login: '/pc/home/login/login',
  // 商家注册
  userRegister: '/pc/home/login/userRegister',
  // 数字验证码
  verifyCode: '/pc/home/login/verifyCode',
  // 退出登录
  logout: '/pc/home/login/logout',
  // 主播切换
  changeAnchor: '/pc/home/login/changeAnchor',
  // 更换绑定微信
  wechatChangeBand: '/pc/home/login/wechatChangeBand',

  /** ************首页********************/
  // 首页主播榜单
  indexRanking: '/pc/home/anchor/feiTang',
  // 首页活动列表
  indexActivity: '/pc/home/activity/index',
  // 首页banner
  advertisement: '/common/config/advertisement',

  /** ************活动********************/
  // 活动广场列表
  activityList: '/pc/home/activity/list',
  // 活动广场报名
  activityAdd: '/pc/home/activity/add',
  // 活动广场详情
  activityInfo: '/pc/home/activity/info',

  /** ************主播********************/
  // 主播列表
  anchorList: '/pc/home/anchor/list',
  // 主播详情
  anchorInfo: '/pc/home/anchor/info',

  /** ************头条********************/
  // 头条列表
  articleList: '/pc/home/article/list',
  // 头条年月
  articleGetDaily: '/pc/home/article/getDaily',
  // 头条类目
  articleArticleType: '/pc/home/article/articleType',
  // 头条详情
  articleInfo: '/pc/home/article/info',

  /** ************短视频********************/
  // 短视频列表
  videoList: '/pc/home/video/list',
  // 其他短视频
  videoOther: '/pc/home/video/other',
  // 短视频类目
  videoCategory: '/pc/home/video/category',
  // 短视频类型
  videoType: '/pc/home/video/type',
  // 短视频详情
  videoInfo: '/pc/home/video/info',
  // 短视频喜欢
  videoLike: '/pc/home/video/like',

  /** ************个人中心商家********************/
  // 个人信息
  businessInfo: '/pc/business/info',
  // 广告获取
  merchantAds: '/pc/merchant/index/ads',
  // 提现账户信息
  merchantWithdrawInfo: '/pc/merchant/withdraw/info',
  // 提现账户修改
  merchantWithdrawEdit: '/pc/merchant/withdraw/edit',
  // 提现账户申请
  merchantWithdrawApply: '/pc/merchant/withdraw/apply',
  // 投诉列表
  complainList: '/pc/home/complain/list',
  // 投诉类型列表
  complainTypes: '/pc/home/complain/complainType',
  // 提交投诉
  complainAdd: '/pc/home/complain/add',
  // 修改密码
  changePassword: '/pc/home/user/changePassword',
  // 订单详情
  orderInfo: '/pc/merchant/order/info',
  anchorCart: '/pc/merchant/order/cartInfo',
  // CPC投放
  orderCpc: '/pc/merchant/order/orderCpc',
  // 通过链接获取商品信息
  getGoodsInfoByUrl: '/pc/merchant/goods/getGoodsInfoByUrl',
  // 商家修改商务
  changeAdmin: '/pc/merchant/index/changeAdmin',
  // 商家的商务下拉列表
  getAllAdmin: '/pc/merchant/index/getAllAdmin',

  /** ************个人中心主播********************/
  // 个人信息
  personalCenterInfo: '/pc/anchor/PersonalCenter/info',
  // 接单账户列表
  OrderReceivingList: '/pc/anchor/OrderReceiving/list',
  // 新增接单账户
  newReceiptAccount: '/pc/anchor/OrderReceiving/newReceiptAccount',
  // 编辑接单账户
  OrderReceivingEdit: '/pc/anchor/OrderReceiving/edit',
  // 提现账户信息
  anchorWithdrawInfo: '/pc/anchor/withdraw/info',
  // 提现账户修改
  anchorWithdrawEdit: '/pc/anchor/withdraw/edit',
  // 提现申请
  anchorWithdrawApply: '/pc/anchor/withdraw/apply',
  // 寄样信息详情
  sendSampleInfo: '/pc/anchor/PersonalCenter/sendSampleInfo',
  // 新增寄样
  sendSampleAdd: '/pc/anchor/PersonalCenter/sendSampleAdd',
  // 编辑寄样
  sendSampleEdit: '/pc/anchor/PersonalCenter/sendSampleEdit',
  // 获取区域列表
  getArea: '/pc/anchor/PersonalCenter/getArea',
  // 获取城市列表
  getCity: '/pc/anchor/PersonalCenter/getCity',
  // 获取省份列表
  getProvince: '/pc/anchor/PersonalCenter/getProvince',

  /** ************绑定微信********************/
  // 获取微信code
  getWeixinCode: '/index/getWeixinCode',
  // 获取微信绑定信息
  getWeixinInfo: '/index/getWeixinInfo',
  // 获取微信二维码
  getWeixinQrcode: '/index/getWeixinQrcode',

  /** ************商家-购物车********************/
  // 购物车列表
  shoppingCartList: '/pc/shoppingCart/list',
  // 已选达人数量
  shoppingCartAmount: '/pc/shoppingCart/amount',
  // 添加数量
  shoppingCartNumExecute: '/pc/shoppingCart/numExecute',
  // 添加购物车
  shoppingCartAdd: '/pc/shoppingCart/add',
  // 删除购物车
  shoppingCartDel: '/pc/shoppingCart/del',
};
